const initialState = {};

export function templatesDifference(state = initialState, action) {
    switch (action.type) {
        default:
            return state;
    }
}
